const COLOR_CODE = {
  light: '#FFFFFF',
  dark: '#333333',
  brand: '#F6703E'
}

export const Colors = {
  light: { 'color': COLOR_CODE.light },
  dark: { 'color': COLOR_CODE.dark },
  brand: { 'color': COLOR_CODE.brand }
}

export const Backgrounds = {
  light: { 'background-color': COLOR_CODE.light  },
  dark: { 'background-color': COLOR_CODE.dark },
  brand: { 'background-color': COLOR_CODE.brand }
}